export const myNgoExplanation = [
  {
    id: '1',
    title: 'Taux d\'engagement "1 €" de mes clients (%)',
    content:
      'Nombre de ventes avec contribution volontaire "1 €" de mes clients sur nombre total de mes ventes '
  },
  {
    id: '2',
    title: 'Somme "1€" de mes clients (€)',
    content: 'Somme totale des contributions de "1 €" de mes clients'
  },
  {
    id: '3',
    title: 'ONG choisie pour mes "1 €"',
    content: "Nom de l'ONG"
  }
];

export const ngoClassExplanation = [
  {
    id: '1',
    title: 'Taux d’engagement "1 €" de la classe (%)',
    content:
      'Nombre de ventes avec contribution volontaire "1 €" de la classe sur nombre total de ventes de la classe'
  },
  {
    id: '2',
    title: 'Contributions "1 €"  de nos clients (€)',
    content: 'Somme totale des contributions de "1 €" des clients de la classe'
  },
  {
    id: '3',
    title: 'ONG choisie pour un don "classe"',
    content: "Nom de l'ONG"
  },
  {
    id: '4',
    title: "Don de la classe = part de la Commission reversée à l'ONG (%)",
    content:
      '% de la commission que la classe a décidé de reverser à une association choisie par le groupe'
  },
  {
    id: '5',
    title: "Don de la classe = somme de la Commission reversée à l'ONG (€)",
    content:
      'Somme en € de la commission que la classe a décidé de reverser à une association choisie par le groupe'
  },
  {
    id: '6',
    title: 'Total (1€ + don Classe + don France Challenges)',
    content:
      'Contributions de "1 €" de nos clients + don de la classe + don de France Challenges équivalant à 0,5% du ca réalisé par la classe'
  }
];
